$(function () {
  if(!isSupported('width','fit-content')) {
    fixFitContent('.swiper-slide .content-inner .neos-contentcollection','.neos-nodetypes-headline > div > *',100);

    fixFitContent('main .neos-nodetypes-headline','h6',20);

    $(window).on('resize',function () {
      fixFitContent('.swiper-slide .content-inner .neos-contentcollection','.neos-nodetypes-headline > div > *',100);

      fixFitContent('main .neos-nodetypes-headline','h6',20);
    })
  }
})

function fixFitContent(container,children,increase) {
  $(container).css('width','').css('margin','');

  var max = 0;
  children = $(container).find(children);
  children.css('display','inline').each(function () {
    if($(this).outerWidth(true) > max) max = $(this).outerWidth(true);
  })
  children.css('display','');

  if(increase && typeof increase === 'number') max += increase;
  $(container).width(max).css('margin','0 auto');
}
